import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { refinePrompt } from '@terminal/services/prompt-refinement/prompt-refinement-service';

const QUERY_KEY_REFINE_PROMPT = 'QUERY_KEY_REFINE_PROMPT';

interface UseRefinePromptQueryParams {
  question: string;
  isEnabled: boolean;
}

export const useRefinePromptQuery = ({
  question,
  isEnabled,
}: UseRefinePromptQueryParams) => {
  const trimmedQuestion = question.trim();

  return useQuery({
    queryKey: [QUERY_KEY_REFINE_PROMPT, trimmedQuestion],
    queryFn: ({ signal }) =>
      refinePrompt({ question: trimmedQuestion, signal }),
    enabled: isEnabled && !!trimmedQuestion,
    staleTime: getTimeTillEndOfDayMs(),
    retry: false,
  });
};
